import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChangePasswordForm = _resolveComponent("ChangePasswordForm")!
  const _component_FinalePopup = _resolveComponent("FinalePopup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ChangePasswordForm, { onOnSubmit: _ctx.changePassword }, null, 8, ["onOnSubmit"]),
    (_ctx.showFinalePopup)
      ? (_openBlock(), _createBlock(_component_FinalePopup, {
          key: 0,
          subMessage: _ctx.$t("POPUP.FINALY.ASIDE"),
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: "ProfileContactDetailsPage" })))
        }, null, 8, ["subMessage"]))
      : _createCommentVNode("", true)
  ]))
}